// import {productVariantChange} from './product.js'
//
// document.addEventListener(
//   'DOMContentLoaded',
//   productVariantChange,
// );

// import { stockAddDeliveryDate } from './stocks.js'
//
// document.addEventListener(
//   'DOMContentLoaded',
//   stockAddDeliveryDate,
// );


import { modelSwitcher, customOption } from './product.js'

document.addEventListener(
  'DOMContentLoaded',
  modelSwitcher,
);
document.addEventListener(
  'DOMContentLoaded',
  customOption,
);
